import { createSelector } from "reselect";

const getTranscripts = (state) =>
  __IS_COMPONENTS_PORTAL__
    ? state.variantResult?.genes?.[state.selectedGeneIndexClinical]?.transcripts
    : state?.variantResult?.transcripts;

const getCanonicalTranscripts = createSelector(
  getTranscripts,
  (transcripts) => {
    if (transcripts) {
      return transcripts.filter((transcript) => {
        return transcript.canonical === true;
      });
    }
    return null;
  }
);

export { getTranscripts, getCanonicalTranscripts };
